import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Brak elementu #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Service worker tylko na produkcji.
 *
 * W developmencie zakeszowany worker przesłaniałby zmiany w kodzie i kazał
 * zgadywać, czy poprawka nie działa, czy tylko nie doszła.
 */
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // Brak service workera oznacza tylko brak trybu offline — gra działa dalej.
    });
  });
}
